module.exports = __webpack_public_path__ + "img/code.b3e0e96a.jpg";